<template>
  <v-tooltip
      :disabled="disabled"
      :location="location"
      :transition="transition"
      open-delay="150"
      v-bind="attrs.componentAttrs"
  >
    <template #activator="{props}">
      <slot name="activator" :props="props" />
    </template>
    <template #default>
      <div :data-locator="attrs.dataLocator" class="font-weight-bold">
        <slot name="default" />
      </div>
    </template>
  </v-tooltip>
</template>

<script>
/**
 * A wrapper around the tooltip with a different default transition
 * All Vuetify props for the tooltip component are usable.
 * @see https://vuetifyjs.com/en/api/v-tooltip/#props
 */

import { useDataLocator } from '@/common/utils/useDataLocator'

export default {
  name: 'AppTooltip',
  inheritAttrs: false,
  setup () {
    const { attrs } = useDataLocator()
    return { attrs }
  },
  props: {
    location: {
      type: String,
      validator (value) {
        return ['start', 'end', 'center', 'top', 'bottom', 'left', 'right'].includes(value)
      },
      default: 'top',
    },
    transition: {
      type: String,
      default: 'fade-transition',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
